import { useParams } from "react-router-dom";

export function UserProfileComponent(): React.JSX.Element {
  let { username } = useParams<{ username: string | undefined }>();
  return <div>
    <h1>{username}'s Profile</h1>
  </div>
}
